<template>
  <a-spin tip="Your document is being processed, do not leave this page!" :spinning="pageLoading">
    <div class="wrapper">
      <div class="wrapper-header">
        <span>
          <a-icon type="wallet" class="margin-right-small" />
          {{ titlepage }}
        </span>
        <div>
          <!-- <a-button
            v-if="tabs.active == 'needprocess'"
            :icon="preparedToGenerate.visible ? 'caret-up' : 'caret-down'"
            @click="handleShowDGenerate"
            :class="preparedToGenerate.visible ? '' : 'margin-right'"
            size="small"
          >
            {{ preparedToGenerate.visible ? 'Back To List' : 'Generate SPT'}}
          </a-button> -->
          <a-button v-if="!preparedToGenerate.visible" @click="handleReload" size="small" icon="reload"></a-button>
        </div>
      </div>
      <div class="wrapper-body">

        <div v-if="preparedToGenerate.visible" class="container-essential" style="margin:3px!important">
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
              <a-select v-model="preparedToGenerate.jenis_spt" class="m-width-full" placeholder="Select SPT Type"
                allow-clear :disabled="this.preparedToGenerate.filtered || this.generate != 'index'">
                <a-select-option value="ppn">PPN</a-select-option>
                <a-select-option value="pph_21">PPh 21</a-select-option>
                <a-select-option value="pph_unifikasi">PPh Unifikasi</a-select-option>
                <a-select-option value="pph_tahunan">PPh Tahunan</a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
              <a-month-picker v-model="preparedToGenerate.bln_thn" id="bln_thn_form"
                :class="getScreen ? 'm-width-full margin-top' : 'm-width-full'" placeholder="Select Periode"
                :format="'MM-YYYY'" allow-clear :disabled="this.preparedToGenerate.filtered">
              </a-month-picker>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
              <a-button type="primary" :class="getScreen ? 'm-width-full margin-top' : 'm-width-full'" icon="filter"
                @click="handleDfilter" v-if="!preparedToGenerate.filtered" :loading="preparedToGenerate.loading.filter">
                Filter
              </a-button>
              <a-button type="danger" :class="getScreen ? 'm-width-full margin-top' : 'm-width-full'" icon="filter"
                @click="handleDfilter" v-if="preparedToGenerate.filtered" :loading="preparedToGenerate.loading.filter"
                :disabled="loading.generate">
                Reset
              </a-button>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
              <a-button type="primary" :class="getScreen ? 'm-width-full margin-top' : 'm-width-full'"
                @click="handleGenerate" :loading="loading.generate" :disabled="!preparedToGenerate.filtered">
                Generate
              </a-button>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
              <h3 style="float:right;margin-top: 0.2em;margin-bottom: 0px!important;">Total Tax Values : {{
                formatCurrency('IDR', preparedToGenerate.tax_value) }}</h3>
            </a-col>
          </a-row>
        </div>
        <a-card>
          <div style="display: none">
            <a-select placeholder="Ex: Need Process ... " v-model="tabs.active" :disabled="true" @change="moreSearch"
              class="width-full" initialValue="process" allowClear>
              <a-select-option value="release">release</a-select-option>
              <a-select-option value="credittax">credittax</a-select-option>
              <a-select-option value="needprocess">needprocess</a-select-option>
            </a-select>
          </div>
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: preparedToGenerate.v_kiri }">
              <a-input-search v-model="search" placeholder="Quick Search" />
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: preparedToGenerate.v_kanan }">
              <div :class="getScreen ? 'margin-top' : ''" style="width:100%;text-align:left"
                v-if="!preparedToGenerate.visible">
                <a-badge :dot="showbadge">
                  <a-button :icon="advancedsearch == 'display:none' ? 'down' : 'up'" @click="handleshowMore">{{
                    advancedsearch == "display:none" ? "More" : "Less"
                  }}</a-button>
                </a-badge>
                &nbsp;
                <a-button type="primary" icon="plus" @click="handleShowModalCreate" :loading="loading.create">
                  Tax Manual
                </a-button>
              </div>
            </a-col>
          </a-row>
          <a-row :style="advancedsearch" :gutter="8" v-if="!preparedToGenerate.visible">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Invoice Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="invoiceDt"
                    :format="getDefaultDateFormat" allowClear />
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt"
                    :format="getDefaultDateFormat" allowClear />
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Tax Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="taxDt" :format="getDefaultDateFormat"
                    allowClear :disabled="preparedToGenerate.dis_TaxDt || tabs.active == 'listSPT'" />
                </div>
              </a-col>
            </a-row>
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Type</label>
                  <a-select placeholder="Ex: All Type ... " v-model="type" class="width-full" initialValue="all">
                    <a-select-option value="all">All Type</a-select-option>
                    <a-select-option value="account_pay"> ACCOUNT PAY </a-select-option>
                    <a-select-option value="account_pay_kewajiban"> ACCOUNT PAY KEWAJIBAN </a-select-option>
                    <a-select-option value="account_receivable"> ACCOUNT RECEIVABLE </a-select-option>
                    <a-select-option value="account_receivable_sales_contract"> ACCOUNT RECEIVABLE SALES CONTRACT
                    </a-select-option>
                    <a-select-option value="adendum"> ADENDUM </a-select-option>
                    <a-select-option value="other_income"> OTHER INCOME </a-select-option>
                    <a-select-option value="other_outcome"> OTHER OUTCOME </a-select-option>
                    <a-select-option value="pi"> PI </a-select-option>
                    <a-select-option value="pi_release"> PI RELEASE </a-select-option>
                    <a-select-option value="po"> PO </a-select-option>
                    <a-select-option value="tax_manual"> TAX MANUAL </a-select-option>
                    <a-select-option value="tax_verification"> TAX VERIFICATION </a-select-option>
                    <a-select-option value="wo"> WO </a-select-option>
                    <a-select-option value="klaim_cc"> KLAIM CC DIREKTUR  </a-select-option>
                    <a-select-option value="klaim_cc_pd"> KLAIM CC PD </a-select-option>
                    <a-select-option value="klaim_cc_pp"> KLAIM CC PP </a-select-option>
                    <a-select-option value="klaim_traveloka"> KLAIM TRAVELOKA  </a-select-option>
                    <a-select-option value="lap_bailout"> BAILOUT FUND REPORT </a-select-option>
                    <a-select-option value="recap_release"> RECAP RELEASE </a-select-option>
                    <a-select-option value="kas_kecil_el"> KAS KECIL ELEKTRONIK  </a-select-option>
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <a-row :gutter="12">
                  <a-col :xs="{ span: 24 }" :lg="{ span: 14 }">
                    <div class="m-form-item-wrapper">
                      <label>Tax Type</label>
                      <a-select placeholder="Ex: All Type ... " v-model="typetransaction" class="width-full"
                        initialValue="all" :disabled="preparedToGenerate.dis_TaxDt">
                        <a-select-option value="all">All Tax Type</a-select-option>
                        <a-select-option v-for="item in getType_tax" :key="item.value" :value="item.value">
                          {{ item.text }}
                        </a-select-option>

                        <!--a-select-option value="all">All transaction</!--a-select-option>
                      <a-select-option value="PO">PO</a-select-option>
                      <a-select-option value="WO">WO</a-select-option>
                      <a-select-option v-if="tabs.active=='queue'" value="Adendum">Addendum</a-select-option>
                      <a-select-option value="Adendum">Adendum</a-select-option> -->
                      </a-select>
                    </div>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                    <div class="m-form-item-wrapper">
                      <label>SPT Generated</label>
                      <a-select placeholder="Ex: All SPT ... " v-model="isgenerateSPT" class="width-full"
                        initialValue="all" :disabled="preparedToGenerate.dis_TaxDt">
                        <a-select-option value="all">All SPT</a-select-option>
                        <a-select-option key="1" value="1">Yes</a-select-option>
                        <a-select-option key="0" value="0">No</a-select-option>
                      </a-select>
                    </div>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Status Document</label>
                  <a-select showSearch v-model="stsDocument" placeholder="Select Status Document" class="width-full"
                    initialValue="all" allowClear :filterOption="filterOption">
                    <a-select-option value="all">All Status Document</a-select-option>
                    <a-select-option value="yes">Document Complete</a-select-option>
                    <a-select-option value="no">Document not Complete</a-select-option>
                  </a-select>
                </div>
              </a-col>
            </a-row>
          </a-row>
        </a-card>
        <div class="bordered">
          <a-tabs class="custom-tabs" :activeKey="tabs.active" @change="handleTab">
            <!-- <template slot="tabBarExtraContent">
              <a-button
                type="dashed"
                icon="filter"
                @click="handleShowModalCreate"
                :loading="loading.create"
                class="margin-right"
                :disabled="true"
              >
                Generate SPT
              </a-button>            
            </template> -->
            <a-tab-pane key="needprocess">
              <template slot="tab">
                <span>Need Process</span>&nbsp;
                <a-badge class="m-badge m-badge-small" :count="needProcess.length"
                  :numberStyle="{ backgroundColor: 'red' }" v-if="needProcess.length > 0">
                </a-badge>
              </template>
              <a-config-provider :locale="getLocalConfigProvider()">
                <a-table :rowKey="(record, index) => {
                  return index.toString();
                }
                  " size="small" bordered :scroll="{ x: 1300 }" :columns="columns.needProcess"
                  v-if="needProcess.length > 0" :dataSource="needProcess" :loading="tabs.loading" :pagination="pagination"
                  :rowClassName="(record, index) => { return record.check == '1' ? 'selectedRow' : '' }">
                  <template slot="nomor" slot-scope="text, data, index">
                    <span>{{
                      (pagination.page - 1) * pagination.pageSize + index + 1
                    }}</span>
                  </template>
                  <template slot="trans_dt" slot-scope="text, data">
                    <span>{{
                      data.trans_dt
                      ? moment(data.trans_dt).format(getDefaultDateFormat)
                      : "-"
                    }}</span><br />
                    <span>{{ data.tlc }}</span>
                  </template>
                  <template slot="invoicedate" slot-scope="text, data">
                    <span>{{
                      data.invoice_dt
                      ? moment(data.invoice_dt).format(getDefaultDateFormat)
                      : "-"
                    }}</span>
                  </template>
                  <template slot="no_trans" slot-scope="text, data">
                    <span v-if="data.type == 'tax_manual'">{{
                      data.no_trans
                    }}</span>
                    <a v-else-if="data.type == 'tax_verification'" @click="handlelinkTaxVerivication(data)">{{
                      data.no_trans }}</a>
                    <a v-else @click="handlelinkNo(data)">{{ data.no_trans }}</a>
                    <br />
                    <b><small>{{ data.type_label }}</small></b>
                  </template>
                  <template slot="tax_dt" slot-scope="text, data">
                    <b>{{ data.tax_type_label }}</b> /<br />
                    <span>{{
                      data.tax_date
                      ? moment(data.tax_date).format(getDefaultDateFormat)
                      : "-"
                    }}</span>

                  </template>
                  <template slot="value_dpp" slot-scope="text, data">
                    <div style="width:100%">
                      <span style="float:center">{{
                        formatCurrency("IDR", data.value_dpp)
                      }} /</span><br />
                      <span style="float:center">{{
                        formatCurrency("IDR", data.value)
                      }}</span>
                    </div>
                  </template>
                  <template slot="document_tax" slot-scope="text, data">
                    <div style="width:100%;text-align:center">
                      {{ data.document_sts == "Document Not Complete" ? "Not Complete" : "Complete" }}
                      <a-tooltip placement="bottomRight" title="View Document">
                        <a-button icon="file" size="small" type="link" v-if="!(
                          data.document_tax &&
                          data.document_tax == 'No File Uploaded'
                        )
                          " @click="handleviewAttacment(data)"></a-button>
                        <a-button v-else :disabled="true" size="small" type="link" icon="file"></a-button>
                      </a-tooltip>
                    </div>
                  </template>
                  <template slot="createby" slot-scope="text, data">
                    <div style="text-align:center">
                      {{ data.tlc_create }} /<br />
                      {{ moment(data.date_create).format(getStandartFormatDate) }}
                    </div>
                  </template>
                  <template slot="object_deposite" slot-scope="text, data">
                    <span>{{
                      data.kode_setoran_pajak ? data.kode_setoran_pajak : "-"
                    }}
                      /<br />
                      {{
                        data.kode_objek_pajak ? data.kode_objek_pajak : "-"
                      }}</span>
                  </template>

                  <template slot="aksi1" slot-scope="text, data">
                    <a-button-group>
                      <a-button @click="handleshowModalDeposit(data)" icon="edit" :loading="loading.modalDeposit &&
                        loading.modalDepositKey == data.id_tax_transaction
                        " :disabled="data.sts_proses == '1' || data.check === '1'"></a-button>
                      <a-button :loading="loading.deletetaxmanual &&
                        loading.modalDepositKey == data.id_transaction
                        " :disabled="data.sts_proses == '1' || data.type != 'tax_manual'"
                        @click="handleDeleteModalDeposit(data)" icon="delete" type="danger"></a-button>
                      <a-button @click="handleshowProcessModalDeposit(data)" icon="login" :loading="loading.process &&
                        loading.modalDepositKey == data.id_tax_transaction
                        "
                        :disabled="data.sts_proses == '1' || data.isspt === '1' || data.document_sts != 'Document Complete'"
                        type="primary"></a-button>
                    </a-button-group>
                  </template>
                  <template slot="aksi2" slot-scope="text, data">
                    <!-- <a-checkbox
                    :checked="data.check=='1' ? true : false"
                    :disabled="action_label=='Set' || closetrans"
                    @change="handledatachecked(data.id)"
                  ></a-checkbox> -->
                    <a-checkbox :disabled="data.sts_proses == '1' || data.isspt == '0' || data.discheck"
                      :checked="data.check == '1' ? true : false"
                      @change="handledatachecked(data.id_tax_transaction)"></a-checkbox>
                  </template>
                </a-table>
              </a-config-provider>
            </a-tab-pane>
            <a-tab-pane key="credittax" v-if="!preparedToGenerate.visible">
              <template slot="tab">
                <span>Credit Tax</span>&nbsp;
                <!-- <a-badge
                  class="m-badge m-badge-small"
                  :count="credittax.length"
                  :numberStyle="{ backgroundColor: 'red' }"
                  v-if="credittax.length > 0"
                >
                </a-badge> -->
              </template>
              <a-table :rowKey="(record, index) => { return index.toString(); }" size="small" bordered
                :scroll="{ x: 1300 }" :columns="columns.credittax" :dataSource="credittax" :loading="tabs.loading">
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (pagination.page - 1) * pagination.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="trans_dt" slot-scope="text, data">
                  <span>{{
                    data.date_create
                    ? moment(data.date_create).format(getDefaultDateFormat)
                    : "-"
                  }}</span><br />
                  <span>{{ data.tlc_create }}</span>
                </template>
                <template slot="invoicedate" slot-scope="text, data">
                  <span>{{
                    data.invoice_dt
                    ? moment(data.invoice_dt).format(getDefaultDateFormat)
                    : "-"
                  }}</span>
                </template>
                <template slot="no_trans" slot-scope="text, data">
                  <span v-if="data.type == 'tax_manual'">{{
                    data.no_trans
                  }}</span>
                  <a v-else-if="data.type == 'tax_verification'" @click="handlelinkTaxVerivication(data)">{{ data.no_trans
                  }}</a>
                  <a v-else @click="handlelinkNo(data)">{{ data.no_trans }}</a>
                  <br />
                  <b><small>{{ data.type_label }}</small></b>
                </template>
                <template slot="tax_dt" slot-scope="text, data">
                  <b>{{ data.tax_type }}</b> /<br />
                  <span>{{
                    data.tax_date
                    ? moment(data.tax_date).format(getDefaultDateFormat)
                    : "-"
                  }}</span>

                </template>
                <template slot="value_dpp" slot-scope="text, data">
                  <div style="width:100%">
                    <span style="float:center">{{
                      formatCurrency("IDR", data.dpp)
                    }} /</span><br />
                    <span style="float:center">{{
                      formatCurrency("IDR", data.tax_value)
                    }}</span>
                  </div>
                </template>
                <template slot="createby" slot-scope="text, data">
                  <div style="text-align:center">
                    {{ data.tlc_create }} /<br />
                    {{ moment(data.date_create).format(getStandartFormatDate) }}
                  </div>
                </template>
                <template slot="jenisspt" slot-scope="text, data">
                  <span>{{
                    data.spt_type_label ? data.spt_type_label : "-"
                  }}</span>
                </template>
                <template slot="masa" slot-scope="text, data">
                  <span>{{
                    data.spt_masa_label ? data.spt_masa_label : "-"
                  }}</span>
                </template>
                <template slot="sptnumber" slot-scope="text, data">
                  <a @click="handleshowManifest2(data)">
                    {{ data.spt_no ? data.spt_no : "-" }}
                  </a>
                </template>
              </a-table>
            </a-tab-pane>
            <!-- <a-tab-pane key="listSPT" v-if="!preparedToGenerate.visible">
              <template slot="tab">
                  <span>List SPT</span>&nbsp;
                  <a-badge
                    class="m-badge m-badge-small"
                    :count="listnotdone"
                    :numberStyle="{ backgroundColor: 'red' }"
                    v-if="listnotdone > 0"
                  >
                  </a-badge>
                </template>
              <a-config-provider :locale="getLocalConfigProvider()">
              <a-table
                :rowKey="(record, index) => {return index.toString();}"
                size="small"
                bordered
                :scroll="{ x: 1000 }"
                :columns="columns.listSPT"
                :dataSource="listSPT"
                :loading="tabs.loading"
              >
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (pagination.page - 1) * pagination.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="trans_dt" slot-scope="text, data">
                  <span>{{
                    data.date_create
                    ? moment(data.date_create).format(getDefaultDateFormat)
                    : "-"
                  }}</span><br/>
                  <span>{{ data.tlc_create }}</span>
                </template>
                <template slot="taxvalue" slot-scope="text, data">
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="data.tax_value"
                  />
                </template>
                <template slot="no_trans" slot-scope="text, data">
                  <span>{{
                    data.spt_no
                  }}</span>
                  <br/>
                  <b><small>{{ data.spt_type_label }}</small></b>
                </template>
                <template slot="compensationvalue" slot-scope="text, data">
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="data.kompensasi_value"
                  />
                </template>
                <template slot="sptvalue" slot-scope="text, data">
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="data.spt_value"
                  />
                  <div style="text-align:right">
                  <small :style="data.keterangan_spt_value=='Kurang Bayar' ? 'color:red' : 'color:green'">({{ data.keterangan_spt_value }})</small>
                  </div>
                </template>
                <template slot="no_spt_rectification" slot-scope="text, data">
                  {{ data.no_spt_rectification }}
                </template>
                <template slot="sptdocument" slot-scope="text, data">
                  <span>xxx</span>
                </template>
                <template slot="status" slot-scope="text, data">
                  <Status :status="data.spt_status=='Done' ?  data.spt_status.toUpperCase() : data.spt_status" />
                </template>
                <template slot="aksi" slot-scope="text, data">
                  <a-button-group>
                    <a-button
                      @click="handleEditDraftSPT(data)"
                      icon="edit"
                      :loading="
                        loading.edit &&
                        loading.modalDepositKey == data.spt_id
                      "
                      :disabled="data.spt_status === 'Done'"
                    ></a-button>
                    <a-button
                      :loading="
                        loading.deletespt &&
                        loading.modalDepositKey == data.spt_id
                      "
                      :disabled="data.spt_status != 'On Process' || data.pembetulan_sts=='1'"
                      @click="handleDeleteSPT(data)"
                      icon="delete"
                      type="danger"
                    ></a-button>
                    <a-button
                      @click="handleshowManifest(data)"
                      icon="eye"
                      :loading="
                        loading.modalDeposit &&
                        loading.modalDepositKey == data.id_tax_transaction
                      "
                      :disabled="data.sts_proses == '1' || data.isspt === '1'"
                      type="primary"
                      ></a-button>
                  </a-button-group>
                </template>
              </a-table>
              </a-config-provider>
            </a-tab-pane> -->
          </a-tabs>
        </div>
      </div>

      <TaxDepositEntry :v-if="modalDepositEntry" :visibleTaxModal="modalDepositEntry" :getType_tax="getType_tax"
        :getListsetoranpajak="dataEdit.listsetoranpajak" :getListobjekpajak="dataEdit.listobjekpajak"
        :tax_type="dataEdit.tax_type" :file_document_tax="dataEdit.document_tax"
        :kode_setoran_pajak="dataEdit.kode_setoran_pajak" :objek_pajak="dataEdit.kode_objek_pajak"
        :id_header="dataEdit.id_transaction" :id_dtl="dataEdit.id_dtl_transaction" :dpp_value="dataEdit.value_dpp"
        :value="dataEdit.value" :file="dataEdit.fileList" :jenis_transaksi="dataEdit.type"
        :type_document="dataEdit.type_document" :no_document="dataEdit.no_document" :tgl_document="dataEdit.tgl_document"
        :tax_date="dataEdit.tax_date" :modeedit="true" />

      <a-modal v-model="modalCreate" v-if="modalCreate" @ok="handleModalCreate" @cancel="handleModalClose"
        :maskClosable="false" :width="800" :footer="null">
        <span slot="title"> <a-icon type="code" />&nbsp;Manual Tax </span>

        <a-form :form="formcreate">
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Jenis Anggaran">
                <a-select showSearch :not-found-content="null" option-filter-prop="children" v-decorator="[
                  'jenis_anggaran',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.jenis_anggaran,
                  },
                ]" @change="handleJenisAnggaran">
                  <a-select-option v-for="item in modalData.jenis_anggaran" :key="item.value">{{ item.text
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Cost Center">
                <a-select :disabled="modalData.costcenter.length == 0" showSearch v-decorator="[
                  'cost_center',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.cost_center,
                  },
                ]" @change="handleCost">
                  <a-select-option v-for="item in modalData.costcenter" :key="item.value">{{ item.text }} ({{
                    item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                  }})</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Peruntukan">
                <a-select :disabled="modalData.peruntukan.length == 0" showSearch v-decorator="[
                  'peruntukan',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.peruntukan,
                  },
                ]" @change="handle_Peruntukan" ref="refperuntukan" optionFilterProp="children"
                  :filterOption="filterOption">
                  <a-select-option v-for="item in modalData.peruntukan" :key="item.value">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Budget Code">
                <a-tree-select v-decorator="[
                  'kode_anggaran',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.treekode_anggaran,
                  },
                ]" show-search style="width: 100%" @select="handlechoiceCost"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="modalData.anggaran.tree"
                  treeNodeFilterProp="children" :filterTreeNode="filterTreeNode" placeholder="Please select"
                  :treeExpandedKeys="modalData.treeExpandedKeys" allow-clear :disabled="modalData.anggaran.loadingtree ||
                    modalData.anggaran.tree == undefined ||
                    modalData.anggaran.tree.length == 0
                    " tree-default-expand-all>
                  <span slot="title" slot-scope="item">
                    <table style="width:100%">
                      <tr>
                        <td>
                          <span>{{ item.texttitle }} -
                            {{ item.kode_anggaran }}</span>
                        </td>
                        <td>
                          <span style="float:right"><b>{{
                            formatRupiah(parseFloat(item.rekap))
                          }}</b></span>
                        </td>
                      </tr>
                    </table>
                  </span>
                  <template slot="suffixIcon"><a-icon :type="modalData.anggaran.loadingtree ? 'loading' : 'down'
                      " />
                  </template>
                </a-tree-select>
              </a-form-item>
              <a-form-item label="Note">
                <a-textarea placeholder="Write the note here ... " :rows="2" v-decorator="[
                  'description',
                  {
                    rules: [{ required: false }],
                    initialValue: dataEdit.description,
                  },
                ]" />
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form-item label="Date of Tax">
                    <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="[
                      'tax_date',
                      {
                        rules: [{ required: true }],
                        initialValue: dataEdit.date_of_tax
                          ? moment(dataEdit.date_of_tax)
                          : null,
                      },
                    ]" />
                  </a-form-item>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form-item label="Tax Type">
                    <a-select v-decorator="[
                      'tax_type',
                      {
                        rules: [{ required: true }],
                        initialValue: dataEdit.type_pajak,
                      },
                    ]" show-search optionFilterProp="children" :filterOption="filterOption"
                      @change="handleChangeTaxType">
                      <a-select-option v-for="item in listtax" :key="item.value" :value="item.value">
                        {{ item.text }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-form-item label="Tax Deposit">
                <a-select v-decorator="[
                  'kode_setoran_pajak',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.tax_deposit,
                  },
                ]" option-filter-prop="children" :filter-option="filterOption" showSearch>
                  <a-select-option v-for="item in modalData.listsetoranpajak" :key="item.value" :value="item.value"
                    :text="item.text">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Tax Object" v-if="!(
                modalData.reftax_type == 'pph_21' ||
                modalData.reftax_type == 'ppn'
              )
                ">
                <a-select v-decorator="[
                  'objek_pajak',
                  {
                    rules: [{ required: false }],
                    initialValue: dataEdit.tax_object,
                  },
                ]" option-filter-prop="children" :filter-option="filterOption" showSearch allowClear>
                  <a-select-option v-for="item in modalData.listobjekpajak" :key="item.value" :value="item.value"
                    :text="item.text">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="DPP Value">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
    'dpp_value',
    {
      rules: [{ required: true, validator: checkPrice }],
      initialValue: dataEdit.dpp_value,
    },
  ]" />
              </a-form-item>
              <a-form-item label="Tax Value">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
    'value',
    {
      rules: [{ required: true, validator: checkPrice }],
      initialValue: dataEdit.tax_value,
    },
  ]" />
              </a-form-item>
              <a-form-item label="File Document Tax">
                <a-upload :fileList="modalData.fileList" v-decorator="[
                  'file_document_tax',
                  {
                    rules: [
                      { required: false, validator: doc_validation },
                    ],
                  },
                ]" :remove="handleRemoveAttachment" :beforeUpload="beforeUploadAttachment">
                  <a-button> <a-icon type="upload" />Select File </a-button>
                </a-upload>
              </a-form-item>
            </a-col>
          </a-row>
          <div class="container-essential" v-if="this.modalData.modeedit && this.modalData.fileList.length > 0">
            <a-row :gutter="12">
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item label="Date Document">
                  <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="[
                    'tgl_document',
                    {
                      rules: [{ required: true }],
                      initialValue: dataEdit.tgl_document ? moment(dataEdit.tgl_document) : null,
                    },
                  ]" />
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item label="Type Document">
                  <a-select
                    v-decorator="['type_document', { rules: [{ required: true }], initialValue: dataEdit.type_document }]">
                    <a-select-option value="Dokumen Faktur Pajak">Dokumen Faktur Pajak</a-select-option>
                    <a-select-option value="Bukti Potong Pajak">Bukti Potong Pajak</a-select-option>
                    <a-select-option value="Dokumen STP">Dokumen STP</a-select-option>
                    <a-select-option value="Dokumen Id Billing">Dokumen Id Billing</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item label="No Document">
                  <a-input
                    v-decorator="['no_document', { rules: [{ required: true }], initialValue: dataEdit.no_document }]"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <a-button type="primary" icon="disk" @click="handleCreateTaxManual" ref="addMainBtn"
            :loading="loading.createtaxmanual" class="m-width-full margin-top">
            Save
          </a-button>
        </a-form>
      </a-modal>

      <a-modal v-model="modalTaxVerification" v-if="modalTaxVerification" :maskClosable="false" :width="1024"
        :footer="null">
        <!-- @ok="handleModalProcess"
          @cancel="handleModalClose" -->
        <span slot="title"> <a-icon type="reconciliation" />&nbsp;Verification Transaction Tax
          {{ modalTax.jenis_transaksi_label }} # {{ modalTax.no_transaction }} </span>
        <div class="container-headertable">
          <div class="m-display-flex space-between align-middle">
            <span>List Details</span>
            <!-- <a-button 
                  v-if="loading.loadJenis != 'view'"
                  @click="handleExpand()"
                  size="small"
                >
                    <span>{{ expand.labelExpand }}</span>
                </a-button> -->
          </div>
        </div>
        <a-config-provider :locale="getLocalConfigProvider()">
          <a-table bordered size="small" id="tbl_dtl" :rowKey="(record, index) => { return index; }"
            :columns="modalTax.columns" :dataSource="modalTax.source" :pagination="modalTax.pagination"
            :scroll="{ x: 835 }" :loading="modalTax.loading">
            <template slot="nomor" slot-scope="text, data,index">
              <div class="m-text-align center">{{ index + 1 }}</div>
            </template>
            <template slot="detail" slot-scope="data">
              <div class="m-text-align left">{{ data.detail }}</div>
              <small v-if="data.kode_anggaran"><i>[{{ data.kode_anggaran + "-" + data.item_anggaran }}]</i></small>
            </template>
            <template slot="notrans" slot-scope="data">
              <div class="m-text-align center">{{ data.no_trans }}</div>
            </template>
            <template slot="type" slot-scope="data">
              <div class="m-text-align left">{{ gettitletax(data.tax_type) }}</div>
            </template>
            <template slot="dppvalue" slot-scope="data">
              <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.dpp_value" />
            </template>
            <template slot="value" slot-scope="data">
              <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.tax_value" />
            </template>
            <template slot="action" slot-scope="text,data,index">
              <div :class="'m-text-align center'">
                <a-button-group>
                  <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="View File">
                    <a-button
                      :disabled="data.tax_document_name == '' || data.tax_document_name == null || loading.spinform"
                      type="default" @click="viewFiledtl(data.tax_document_name, data.tax_document_path)" icon="file"
                      size="small">
                    </a-button>
                  </a-tooltip>
                </a-button-group>
              </div>
            </template>
            <!-- <template slot="footer">
                <a-row :gutter="16">
                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <a-statistic
                      title="Total Deduction"
                      :value="formatCurrency('IDR', totalVerificationdtl)"
                      class="m-text-align left"
                    />
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <a-statistic
                      title="Real Value AR"
                      :value="formatCurrency('IDR', realAR ? realAR : 0)"
                      class="m-text-align left"
                    />
                  </a-col>
                </a-row>
              </template> -->
          </a-table>
        </a-config-provider>
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod";
import CheckboxAll from "@/components/CheckboxAllHeader.vue";
import TaxDepositEntry from "@/components/TaxDepositEntry.vue";
import _ from "lodash";
import CryptoJS from "crypto-js";

export default {
  name: "account-pay-index",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  components: { CheckboxAll, TaxDepositEntry },
  props: ["generate"],
  data() {
    const columns = {
      listSPT: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No / Type",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 250,
        },
        {
          title: "Date / TLC",
          key: "date",
          align: "center",
          scopedSlots: { customRender: "trans_dt" },
          width: 100,
        },
        {
          title: "Tax Value",
          key: "taxvalue",
          align: "center",
          scopedSlots: { customRender: "taxvalue" },
          width: 150,
        },
        {
          title: "Compensation Value",
          key: "compensationvalue",
          align: "center",
          scopedSlots: { customRender: "compensationvalue" },
          width: 150,
        },
        {
          title: "Remaining Value",
          key: "sptvalue",
          align: "center",
          scopedSlots: { customRender: "sptvalue" },
          width: 150,
        },
        {
          title: "No SPT Rectification",
          key: "no_spt_rectification",
          align: "left",
          scopedSlots: { customRender: "no_spt_rectification" },
          width: 200,
        },
        {
          title: "Status",
          key: "status",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "status" },
          width: 100,
        },
        {
          title: "Action",
          fixed: "right",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "aksi" },
        },
      ],
      credittax: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No / Type",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 250,
        },
        {
          title: "Date / TLC",
          key: "date",
          align: "center",
          scopedSlots: { customRender: "trans_dt" },
          width: 100,
        },
        {
          title: "Invoice Date",
          key: "invoicedate",
          align: "center",
          scopedSlots: { customRender: "invoicedate" },
          width: 100,
        },
        {
          title: "Tax Type / Tax Date",
          key: "tax_date",
          align: "center",
          scopedSlots: { customRender: "tax_dt" },
          width: 150,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 200,
        },
        {
          title: "DPP / Tax Value",
          key: "value_dpp",
          align: "center",
          scopedSlots: { customRender: "value_dpp" },
          width: 150,
        },
        {
          title: "SPT Type",
          key: "jenisspt",
          scopedSlots: { customRender: "jenisspt" },
          width: 200,
        },
        {
          title: "Periode",
          key: "masa",
          scopedSlots: { customRender: "masa" },
          width: 150,
        },
        {
          title: "SPT Number",
          key: "sptnumber",
          scopedSlots: { customRender: "sptnumber" },
          width: 200,
        },
      ],
      needProcess: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No / Type",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 250,
        },
        {
          title: "Date / TLC",
          key: "date",
          align: "center",
          scopedSlots: { customRender: "trans_dt" },
          width: 100,
        },
        {
          title: "Invoice Date",
          key: "invoicedate",
          align: "center",
          scopedSlots: { customRender: "invoicedate" },
          width: 100,
        },
        {
          title: "Tax Type / Tax Date",
          key: "tax_date",
          align: "center",
          scopedSlots: { customRender: "tax_dt" },
          width: 150,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 200,
        },
        {
          title: "DPP / Tax Value",
          key: "value_dpp",
          align: "center",
          scopedSlots: { customRender: "value_dpp" },
          width: 150,
        },
        {
          title: "Deposite Code / Tax Object",
          key: "object_deposite",
          align: "center",
          scopedSlots: { customRender: "object_deposite" },
          width: 200,
        },
        {
          title: "Create By",
          key: "createby",
          scopedSlots: { customRender: "createby" },
          width: 150,
        },
        {
          title: "Status Document",
          key: "document_tax",
          scopedSlots: { customRender: "document_tax" },
          width: 200,
        },
        {
          title: <CheckboxAll textlabel="Action" />,
          fixed: "right",
          colSpan: 2,
          scopedSlots: { customRender: "aksi1" },
          width: 110,
        },
        {
          fixed: "right",
          align: "center",
          width: 50,
          scopedSlots: { customRender: "aksi2" },
        },
      ],
    };
    let doc_validation = (rule, value, callback) => {
      if (this.modalData.fileList && this.modalData.fileList == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    return {
      doc_validation,
      columns,
      pageLoading: false,
      loading: {
        modalDepositKey: "",
        modalDeposit: false,
        create: false,
        createtaxmanual: false,
        deletetaxmanual: false,
        generate: false,
        process: false,
        edit: false,
        deletespt: false,
      },
      tabs: {
        active: "needprocess",
        loading: false,
      },
      listSPT: [],
      needProcess: [],
      credittax: [],
      listSPT_origin: [],
      needProcess_origin: [],
      credittax_origin: [],
      search: undefined,
      typetransaction: "all",
      isgenerateSPT: "all",
      type: "all",
      transactionDt: [],
      invoiceDt: [],
      invoiceDttmpOri: [],
      taxDt: [],
      buktiTransfer: [],
      modalDepositEntry: false,
      advancedsearch: "display:none",
      needProcessSuplier: [],
      quequeSuplier: [],
      listSuplier: [],
      stsDocument: "all",
      revisedStatus: "all",
      dataEdit: [],
      modalCreate: false,
      modalData: {
        costcenter: [],
        costcenterOri: [],
        jenis_anggaran: [],
        kode_anggaran: [],
        kode_anggaranOri: [],
        peruntukan: [],
        peruntukanOri: [],
        sub_peruntukan: [],
        sub_peruntukanOri: [],
        treeExpandedKeys: [],
        anggaran: {
          tree: [],
          loadingtree: false,
        },
        listsetoranpajak: [],
        listsetoranpajakOri: [],
        listobjekpajak: [],
        fileList: [],
      },
      urlgetObjec_setran_pajak: "tax_transaction/objek_setoran_pajak",
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      modalTaxVerification: false,
      modalTax: {
        jenis_transaksi_label: "-",
        no_transaction: "",
        source: [],
        pagination: {
          onChange: (page) => {
            this.modalTax.pagination.page = page;
          },
          page: 1,
          pageSize: 10,
          size: "small",
        },
        columns: [
          {
            title: "#",
            key: "nomor",
            scopedSlots: { customRender: "nomor" },
            width: 50,
          },
          {
            title: "No. Transaction",
            key: "notrans",
            scopedSlots: { customRender: "notrans" },
            width: 150,
          },
          {
            title: "Detil transaction",
            key: "detail",
            scopedSlots: { customRender: "detail" },
            width: 250,
          },
          {
            title: "Type tax",
            key: "type",
            scopedSlots: { customRender: "type" },
            width: 150,
          },
          {
            title: "DPP Value",
            key: "dppvalue",
            scopedSlots: { customRender: "dppvalue" },
            width: 150,
          },
          {
            title: "Value",
            key: "value",
            scopedSlots: { customRender: "value" },
            width: 150,
          },
          {
            title: "View",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "action" },
            width: 85,
          },
        ],
      },
      preparedToGenerate: {
        filtered: false,
        jenis_spt: undefined,
        bln_thn: undefined,
        visible: false,
        loading: {
          filter: false,
        },
        v_kiri: 17,
        v_kanan: 7,
        tax_value: 0,
        dis_TaxDt: false,
      },
    };
  },
  beforeCreate() {
    this.formDepositEntry = this.$form.createForm(this);
    this.formcreate = this.$form.createForm(this);
  },
  mounted() {
    Event.$on("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$on("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("checkboxallselectReturn", this.handlecheckall);
    this.$store.dispatch("Fetch_TYPE_TAX");
    if (this.$attrs.tabsActive) {
      this.handleTab(this.$attrs.tabsActive);
    }

    if (this.generate != 'index') {
      this.handleShowDGenerate();
      this.preparedToGenerate.jenis_spt = this.generate;
    }
    this.defaultfilterInvoiceDate();
  },
  beforeDestroy() {
    Event.$off("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$off("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("checkboxallselectReturn", this.handlecheckall);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getType_tax",
    ]),
    isAkuntansi() {
      return this.$route.name == "Spclaccount-pay-index" &&
        this.$route.path == "/akuntansiKeuangan/account_pay"
        ? true
        : false;
    },
    moreSearch: function () {
      this.processmoreSearch();
      return true;
    },
    listtax() {
      return _.filter(this.getType_tax, (el) => el.value !== "bea_masuk");
    },
    showbadge() {
      let result = false;
      if ((this.invoiceDt && this.invoiceDt.length > 0 && this.invoiceDt[0] != null && this.invoiceDt[1] != null) || (this.transactionDt && this.transactionDt.length > 0) ||
        (this.taxDt && this.taxDt.length > 0)
        || (this.type && this.type != 'all') || (this.typetransaction && this.typetransaction != 'all') ||
        (this.stsDocument && this.stsDocument != 'all')) {
        result = true;
      }
      return result;
    },
    listnotdone() {
      let result = _.filter(this.listSPT_origin, (el) => el.spt_status && el.spt_status != "Done")
      return result.length;
    },
    titlepage() {
      if (this.generate != 'index') {
        return 'Generate SPT'
      } else {
        return 'Tax Transaction List'
      }
    }
  },
  created() {
    this.handleReload();
  },
  watch: {
    generate() {
      if (this.generate && this.generate == 'index') {
        this.preparedToGenerate.v_kiri = 17;
        this.preparedToGenerate.v_kanan = 7;
        this.preparedToGenerate.visible = false
        this.preparedToGenerate.filtered = false;
        this.handleReload()
      }
    }
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.pagination.page = 1;
      if (this.tabs.active == 'listSPT') {
        this.taxDt = undefined;
      } else {
        this.taxDt = [];
        this.taxDt[0] = this.moment().startOf('year');
        this.taxDt[1] = this.moment().endOf('year');
      }
      this.type = undefined;
      this.typetransaction = "all";
      this.stsDocument = "all";
      this.isgenerateSPT = "all";
    },
    intoList(type, value) {
      if (type == "listSPT") {
        this.listSPT = value;
      } else if (type == "credittax") {
        this.credittax = value;
      } else {
        this.needProcess = value;
        if (this.preparedToGenerate.filtered) {
          this.generateTax_value();
        }
      }
    },
    async handleReload() {
      this.pageLoading = true;
      let tab = "";
      if (this.tabs.active == 'needprocess') {
        tab = 'need_proses';
      } else if (this.tabs.active == 'credittax') {
        tab = 'credit_tax';
      } else if (this.tabs.active == 'listSPT') {
        tab = 'spt_queue';
      } else {
        tab = 'spt_done';
      }
      await this.asyncAxiosGet("tax_transaction", this.getAuth, {
        tlc: this.getAuth.username,
        tab: tab
      })
        .then((res) => {
          if (res.spt_queue) {
            this.listSPT = res.spt_queue;
            this.listSPT_origin = res.spt_queue;
          }

          if (res.credit_tax_list) {
            this.credittax = res.credit_tax_list;
            this.credittax_origin = res.credit_tax_list;
          }

          if (res.need_process) {
            this.needProcess_origin = res.need_process;
            this.needProcess_origin.forEach((item, index) => {
              this.needProcess_origin[index]["check"] = "0";
              this.needProcess_origin[index]["discheck"] = true;
            });
            this.needProcess = this.needProcess_origin;
          }

          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      this.resetSearch();
      return true;
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
      if (val === "needprocess") {
        this.listSuplier = this.needProcessSuplier;
        this.revisedStatus = "all";
      } else if (val === "credittax") {
        this.listSuplier = this.quequeSuplier;
      } else if (val === "release") {
        this.listSuplier = this.releaseSuplier;
      }
      this.handleReload();
    },
    handleCreate(item) {
      this.$router.push({
        name: "account-pay-create",
        params: { id: item.id, type: item.jenis_id },
      });
    },
    handleCreateAddendum(item) {
      this.$router.push({
        name: "createAddendum",
        params: { id: item.id, jenis_transaksi: item.jenis_transaksi },
      });
    },
    handleRelease(item) {
      this.$store
        .dispatch("releaseQueue", {
          auth: this.getAuth,
          id_ap: item.id_account_pay,
          id: item.id,
          jenis_transaksi: item.jenis_transaksi,
        })
        .then((res) => {
          this.$router.go();
          this.displayMessage("success-release");
        });
    },
    handleManifestRef(item) {
      const data = {
        rest_api:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.jenis_transaksi.toLowerCase()
            : "accountpay",
        id_manifest:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.id
            : item.id_account_pay,
        tlc: this.getAuth.username,
        user_pembuat: item.tlc_create,
      };

      this.handleView(data);
    },
    handleshowModalDeposit(item) {
      if (item.type == "tax_manual") {
        this.loading.modalDepositKey = item.id_tax_transaction;
        this.loading.modalDeposit = true;
        this.modalData.modeedit = true;

        this.asyncAxiosGet("tax_transaction/edit", this.getAuth, {
          id_transaction: item.id_transaction,
        })
          .then((response) => {
            this.dataEdit = response;
            this.dataEdit.treekode_anggaran = response.peruntukan + ";" + response.sub_peruntukan + ";" + response.kode_anggaran;

            this.asyncAxiosGet("main/cost_center", this.getAuth, {
              tlc: this.getAuth.username,
            })
              .then((res) => {
                this.modalData.costcenterOri = res.cost_center;
                this.modalData.costcenter = res.cost_center;
                this.modalData.kode_anggaranOri = res.kode_anggaran;
                this.modalData.jenis_anggaran = res.jenis_anggaran;
                this.modalData.peruntukanOri = res.peruntukan;
                this.modalData.peruntukan = _.filter(res.peruntukan, (el) => el.anggaran_id == this.dataEdit.cost_center);
                this.modalData.sub_peruntukanOri = res.sub_peruntukan;
                this.modalData.sub_peruntukan = res.sub_peruntukan;

                this.asyncAxiosGet("tax_transaction/tree_anggaran", this.getAuth, {
                  anggaran_id: this.dataEdit.cost_center,
                  peruntukan_id: this.dataEdit.peruntukan,
                })
                  .then((res) => {
                    this.modalData.anggaran.tree = res.tree;
                    this.modalData.treeExpandedKeys = this.getParent(
                      this.modalData.anggaran.tree
                    );
                    this.modalData.anggaran.loadingtree = false;
                  })
                  .catch((err) => {
                    this.modalData.anggaran.loadingtree = false;
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error-other", responses.message);
                  });

                this.asyncAxiosGet(
                  this.urlgetObjec_setran_pajak,
                  this.getAuth,
                  { tlc: this.getAuth.username }
                )
                  .then((res2) => {
                    //this.modalData.listsetoranpajak = res2.setoran;
                    this.modalData.listsetoranpajak = [];
                    this.modalData.listsetoranpajakOri = res2.setoran;
                    this.filtertaxDeposit(this.dataEdit.type_pajak);
                    this.modalData.listobjekpajak = res2.objek;

                    this.loading.modalDepositKey = "";
                    this.loading.modalDeposit = false;

                    // this.dataEdit.type_document
                    // this.dataEdit.no_document
                    // this.dataEdit.tgl_document

                    if (
                      this.dataEdit.file_document_tax &&
                      this.dataEdit.file_document_tax != "No File Uploaded"
                    ) {
                      let typefile = this.fileTypeFromUrl(
                        this.dataEdit.file_document_tax
                      );
                      let file = this.dataURLtoFile(
                        typefile + this.dataEdit.file_document,
                        this.dataEdit.file_document_tax
                      );
                      file.uid = "vc-upload-1-1";
                      file.status = "done";
                      file.url =
                        this.$serviceUrl + this.dataEdit.path_document_tax;
                      this.modalData.fileList = [];
                      this.modalData.fileList.push(file);
                    } else {
                      this.modalData.fileList = [];
                    }
                    this.modalCreate = !this.modalCreate;
                  })
                  .catch((err) => {
                    this.loading.modalDepositKey = "";
                    this.loading.modalDeposit = false;
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error-other", responses.message);
                  });
              })
              .catch((err) => {
                this.loading.create = false;
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error-other", responses.message);
              });
          })
          .catch((err) => {
            this.loading.modalDepositKey = "";
            this.loading.modalDeposit = false;
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.loading.modalDepositKey = item.id_tax_transaction;
        this.loading.modalDeposit = true;
        this.dataEdit = item;

        this.asyncAxiosGet(this.urlgetObjec_setran_pajak, this.getAuth, {
          tlc: this.getAuth.username,
        })
          .then((res) => {
            this.dataEdit.listsetoranpajak = _.filter(res.setoran, (item) => item.id_type_tax == this.dataEdit.tax_type);
            this.filtertaxDeposit(this.dataEdit.type_pajak);
            this.dataEdit.listobjekpajak = res.objek;

            if (item.document_tax && item.document_tax != "No File Uploaded") {
              this.asyncAxiosGet("main/base_64", this.getAuth, {
                path: item.document_path,
              })
                .then((response) => {
                  let typefile = this.fileTypeFromUrl(item.document_tax);
                  let file = this.dataURLtoFile(
                    typefile + response.file_document_tax,
                    item.document_tax
                  );
                  file.uid = "vc-upload-1-1";
                  file.status = "done";
                  file.url = this.$serviceUrl + item.document_path;
                  this.dataEdit.fileList = [];
                  this.dataEdit.fileList.push(file);

                  this.loading.modalDeposit = false;
                  this.modalDepositEntry = !this.modalDepositEntry;
                })
                .catch((err) => {
                  console.log(err);
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error-other", responses.message);
                });
            } else {
              this.loading.modalDeposit = false;
              this.modalDepositEntry = !this.modalDepositEntry;
            }
          })
          .catch((err) => {
            this.loading.modalDeposit = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      }
    },
    handleshowProcessModalDeposit(item) {
      const that = this;
      let title = "Are you sure to process this data?";

      this.$confirm({
        title: title,
        content: null,//"Batal / OK?",
        onOk() {
          that.loading.process = true;
          that.loading.modalDepositKey = item.id_tax_transaction;
          that.asyncAxiosPut("Tax_transaction/proses", "application/json", that.getAuth, {
            id_tax_transaction: item.id_tax_transaction,
          })
            .then((response) => {
              that.loading.process = false;
              that.loading.modalDepositKey = "";
              if (response.status && response.status == true) {
                that.displayMessageValue("success-other", response.message);
              } else {
                let responses = Object.assign({}, response);
                that.displayMessageValue("error-other", responses);
              }
              that.$router.push({
                name: "taxRelease",
                params: {},
              });
            })
            .catch((err) => {
              console.log(err);
              that.loading.process = false;
              that.loading.modalDepositKey = "";
              let responses = Object.assign({}, err.response.data);
              that.displayMessageValue("error-other", responses.message);
            });
        },
        onCancel() { },
      });
    },
    handleManifest(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleManifestQueue(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleDocument(item) {
      this.$store
        .dispatch("getBuktiAP", { auth: this.getAuth, id: item.id })
        .then((res) => {
          this.buktiTransfer = res.data.data;
          this.modalDepositEntry = true;
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleClose() {
      this.modalDepositEntry = false;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },

    handleviewAttacment(item) {
      window.open(this.$serviceUrl + item.document_path);
    },
    handledatachecked(val) {
      let ind = _.findIndex(this.needProcess_origin, (e) => {
        return e.id_tax_transaction == val;
      }, 0);
      if (this.needProcess_origin[ind].document_sts == "Document Complete") {
        this.needProcess_origin[ind].check = (this.needProcess_origin[ind].check === "1" ? "0" : "1");
        this.generateTax_value();
      } else {
        this.displayMessageValue("basic-warning", "Can't be checked, Document is not complete!");
        return false;
      }

      //return true
    },
    taxDepositEntryCancel() {
      this.dataEdit = [];
      this.modalDepositEntry = !this.modalDepositEntry;
    },
    handleShowModalCreate() {
      this.dataEdit = [];
      this.dataEdit = [];
      this.modalData.anggaran.tree = [];
      this.modalData.costcenterOri = [];
      this.modalData.costcenter = [];
      this.modalData.kode_anggaranOri = [];
      this.modalData.jenis_anggaran = [];
      this.modalData.peruntukanOri = [];
      this.modalData.peruntukan = [];
      this.modalData.sub_peruntukanOri = [];
      this.modalData.sub_peruntukan = [];
      this.modalData.fileList = [];
      this.modalData.modeedit = false;

      this.loading.create = true;
      this.asyncAxiosGet("main/cost_center", this.getAuth, {
        tlc: this.getAuth.username,
      })
        .then((res) => {
          this.modalData.costcenterOri = res.cost_center;
          this.modalData.jenis_anggaran = res.jenis_anggaran;
          this.modalData.kode_anggaranOri = res.kode_anggaran;
          this.modalData.peruntukanOri = res.peruntukan;
          this.modalData.sub_peruntukanOri = res.sub_peruntukan;

          this.asyncAxiosGet(this.urlgetObjec_setran_pajak, this.getAuth, {
            tlc: this.getAuth.username,
          })
            .then((res) => {
              //this.modalData.listsetoranpajak = res.setoran;
              this.modalData.listsetoranpajak = [];
              this.modalData.listsetoranpajakOri = res.setoran;
              this.modalData.listobjekpajak = res.objek;

              this.loading.create = false;
              this.modalCreate = !this.modalCreate;
            })
            .catch((err) => {
              this.loading.create = false;
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        })
        .catch((err) => {
          this.loading.create = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    handleModalCreate() {
      this.modalCreate = !this.modalCreate;
    },
    handleModalClose() {
      this.modalCreate = !this.modalCreate;
    },
    handleJenisAnggaran(e) {
      this.formcreate.setFieldsValue({
        cost_center: null,
        peruntukan: null,
        sub_peruntukan: null,
        kode_anggaran: null,
      });
      const filter = this.modalData.costcenterOri.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.modalData.costcenter = filter;
      this.modalData.peruntukan = [];
      // this.anggaran.tree = [];
      // this.anggaran.treeModal = [];
      this.modalData.subPeruntukan = [];
    },
    handleCost(e) {
      this.$nextTick(function () {
        this.formcreate.setFieldsValue({
          peruntukan: null,
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.modalData.subPeruntukan = [];
      // this.modalData.anggaran.tree = [];
      // this.modalData.anggaran.treeModal = [];
      const peruntukan = this.modalData.peruntukanOri.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.modalData.peruntukan = peruntukan;
      // this.modalData.anggaran.anggaran_id = e;
      // this.modalData.data.cost_center_id = e;
    },
    handle_Peruntukan(e) {
      this.modalData.anggaran.loadingtree = true;
      let params = this.formcreate.getFieldsValue();
      this.asyncAxiosGet("tax_transaction/tree_anggaran", this.getAuth, {
        anggaran_id: params.cost_center,
        peruntukan_id: e,
      })
        .then((res) => {
          this.modalData.anggaran.tree = res.tree;
          this.modalData.treeExpandedKeys = this.getParent(
            this.modalData.anggaran.tree
          );
          this.modalData.anggaran.loadingtree = false;
        })
        .catch((err) => {
          this.modalData.anggaran.loadingtree = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    handlechoiceCost(item) {
    },
    filterTreeNode(input, option) {
      //console.log(input, option)
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeTaxType(e) {
      this.modalData.reftax_type = e;
      this.$nextTick(function () {
        this.formcreate.setFieldsValue({
          kode_setoran_pajak: null,
        });
      });
      this.filtertaxDeposit(e);
    },
    filtertaxDeposit(val) {
      this.modalData.listsetoranpajak = _.filter(this.modalData.listsetoranpajakOri, (item) => item.id_type_tax == val);
    },
    preventEnterButton() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.addMainBtn.$children[0].$el.focus();
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    beforeUploadAttachment(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.modalData.fileList = [];
        this.modalData.fileList.push(file);

        this.$nextTick(function () {
          this.formcreate.setFieldsValue({
            type_document: null,
            no_document: null,
            tgl_document: null,
          });
        });
        return false;
      }
    },
    handleRemoveAttachment() {
      this.modalData.fileList = [];
      this.modalData.type_document = null;
      this.modalData.no_document = null;
      this.modalData.tgl_document = null;
    },
    handleCreateTaxManual() {
      this.formcreate.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        this.loading.createtaxmanual = true;
        let data = new FormData();
        if (this.dataEdit && this.dataEdit.id_transaction)
          data.append("id_transaction", this.dataEdit.id_transaction);
        data.append("tlc", this.getAuth.username);
        data.append(
          "date_of_tax",
          moment(values.tax_date).format("YYYY-MM-DD")
        );
        data.append("type_pajak", values.tax_type);
        data.append("tax_deposit", values.kode_setoran_pajak ? values.kode_setoran_pajak : "");
        let newCode = values.kode_anggaran.split(";");
        data.append("kode_anggaran", newCode[newCode.length - 1]);
        data.append("tax_value", values.value);
        data.append("tax_object", values.objek_pajak ? values.objek_pajak : "");
        data.append("description", values.description ? values.description : "");
        data.append("dpp_value", values.dpp_value);
        if (this.modalData.fileList.length > 0)
          data.append("file_document_tax", this.modalData.fileList[0]);

        if (this.modalData.modeedit && this.modalData.fileList.length > 0) {
          data.append("tgl_document", moment(values.tgl_document).format(this.getStandartFormatDate));
          data.append("type_document", values.type_document);
          data.append("no_document", values.no_document);
        }

        let url = "";
        if (this.dataEdit && this.dataEdit.id_transaction) {
          url = "Tax_transaction/edit";
        } else {
          url = "Tax_transaction";
        }

        this.asyncAxiosPost(url, "formdata", this.getAuth, data)
          .then(() => {
            this.loading.createtaxmanual = false;
            this.modalCreate = !this.modalCreate;
            this.displayMessage("success-save");
            this.handleReload();
          })
          .catch((err) => {
            console.log(err);
            this.modalCreate = !this.modalCreate;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
            this.loading.createtaxmanual = false;
          });
      });
    },
    taxDepositEntryUpdate() {
      this.modalData.fileList = [];
      this.modalData.type_document = null;
      this.modalData.no_document = null;
      this.modalData.tgl_document = null;
      if (this.preparedToGenerate.filtered) {
        this.pageLoading = true;
        let tab = "";
        if (this.tabs.active == 'needprocess') {
          tab = 'need_proses';
        } else if (this.tabs.active == 'credittax') {
          tab = 'credit_tax';
        } else if (this.tabs.active == 'listSPT') {
          tab = 'spt_queue';
        } else {
          tab = 'spt_done';
        }
        this.asyncAxiosGet("tax_transaction", this.getAuth, {
          tlc: this.getAuth.username,
          tab: tab
        })
          .then((res) => {
            if (res.spt_queue) {
              this.listSPT = res.spt_queue;
              this.listSPT_origin = res.spt_queue;
            }

            if (res.credit_tax_list) {
              this.credittax = res.credit_tax_list;
              this.credittax_origin = res.credit_tax_list;
            }

            if (res.need_process) {
              this.needProcess_origin = res.need_process;
              this.needProcess_origin.forEach((item, index) => {
                this.needProcess_origin[index]["check"] = "0";
                this.needProcess_origin[index]["discheck"] = true;
              });
              this.needProcess = this.needProcess_origin;
            }

            this.preparedToGenerate.filtered = false;
            this.handleDfilter();

            this.pageLoading = false;
          })
          .catch((err) => {
            this.pageLoading = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.handleReload();
      }
    },
    handleDeleteModalDeposit(item) {
      this.confirmMessageValue("confirm-delete", item);
    },
    delete(item) {
      this.loading.deletetaxmanual = true;
      this.loading.modalDepositKey = item.id_transaction;

      this.asyncAxiosDelete(
        "Tax_transaction",
        "application/json",
        this.getAuth,
        { id_transaction: item.id_transaction }
      )
        .then(() => {
          this.loading.deletetaxmanual = false;
          this.loading.modalDepositKey = "";
          this.displayMessage("success-save");
          this.handleReload();
        })
        .catch((err) => {
          console.log(err);
          this.loading.deletetaxmanual = false;
          this.loading.modalDepositKey = "";
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    handlelinkNo(item) {
      item.rest_api = item.type.toLowerCase();
      item.id_manifest = item.id_transaction;
      item.user_pembuat = item.tlc;
      item.tab = "release";
      item.jns = "Penerimaan_Kontrak";
      item.jenis = "Penerimaan_Kontrak";
      console.log(item)
      this.handleView(item, true);
    },
    handlelinkTaxVerivication(item) {
      this.modalTaxVerification = true;
      this.modalTax.loading = true;
      this.asyncAxiosGet("tax_verification", this.getAuth, {
        id_transaksi: item.id_transaction,
        jenis_transaksi: item.type
      })
        .then((res) => {
          //     this.modalData.costcenterOri = res.cost_center;
          // this.modalData.id_header = res.id_header;
          this.modalTax.source = res.list_tax_dtl;
          this.modalTax.jenis_transaksi_label = res.jenis_transaksi_lbl;
          this.modalTax.no_transaction = res.no_transaction;
          // for (let w = 0; w < this.modalData.detil_transaction.length; w++) {
          //   this.modalData.detil_transaction[w].disabled = false;
          // }
          //this.modalData.listsetoranpajak = res.setoran;
          // this.modalData.listsetoranpajakOri = res.setoran;
          // this.modalData.listobjekpajak = res.objek;
          // if (res.list_tax_dtl) {
          //   this.verificationdtl_source = res.list_tax_dtl;
          //   for (let x = 0; x < this.verificationdtl_source.length; x++) {
          //     if (this.verificationdtl_source[x].id == undefined)
          //       this.verificationdtl_source[x].id = this.verificationdtl_source[x].id_dtl;
          //   }
          // }
          // this.dtlmodalchange();

          // this.loading.create = false;
          // this.modalProcess = !this.modalProcess;
          // this.loading.modalProcess = false;

          this.modalTax.loading = false;
        })
        .catch((err) => {
          this.modalTax.loading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    gettitletax(val) {
      let res = _.filter(this.getType_tax, (el) => el.value == val);
      return res.length > 0 ? res[0].text : "-";
    },
    modalTaxVerificationClose() {
      this.modalTax.jenis_transaksi_label = "-";
      this.modalTax.no_transaction = "";
      this.modalTax.source = [];
    },
    filterProper() {
      if (this.preparedToGenerate.v_kiri == 17) {
        this.preparedToGenerate.v_kiri = 24;
        this.preparedToGenerate.v_kanan = 0;
      } else {
        this.preparedToGenerate.v_kiri = 17;
        this.preparedToGenerate.v_kanan = 7;
      }
    },
    handleShowDGenerate() {
      if (!this.preparedToGenerate.visible) {
        this.preparedToGenerate.visible = !this.preparedToGenerate.visible;
        this.filterProper();
      } else {
        const that = this;
        this.$confirm({
          title: "Are you sure to discard this data?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            that.preparedToGenerate.visible = false;
            that.preparedToGenerate.dis_TaxDt = false;
            that.invoiceDt = that.invoiceDttmpOri;
            that.preparedToGenerate.jenis_spt = undefined;
            that.preparedToGenerate.bln_thn = undefined;
            that.preparedToGenerate.filtered = false;
            that.preparedToGenerate.tax_value = 0;
            that.needProcess_origin.forEach((item, index) => {
              that.needProcess_origin[index]["discheck"] = true;
              that.needProcess_origin[index]["check"] = "0";
            });
            that.filterProper();
            Event.$emit("setvalcheckboxallselect", false);
            Event.$emit("setdisabledcheckboxallselect", true);
            that.handleReload();
          },
          onCancel() { },
        });
      }
    },
    handleDfilter() {
      if (!this.preparedToGenerate.filtered) {
        if (this.preparedToGenerate.jenis_spt && this.preparedToGenerate.bln_thn) {
          //this.processmoreSearch(); 
          Event.$emit("setvalcheckboxallselect", false);
          Event.$emit("setdisabledcheckboxallselect", false);
          this.needProcess_origin.forEach((item, index) => {
            this.needProcess_origin[index]["discheck"] = false;
            this.needProcess_origin[index]["check"] = "0";
          });
          let a = this.needProcess;
          a.forEach((item) => {
            let index = _.findIndex(
              this.needProcess_origin,
              (e) => {
                return e.id_dtl_transaction == item.id_dtl_transaction;
              }, 0);

            // if (!(this.needProcess_origin[index].sts_proses == '1' ||
            //   this.needProcess_origin[index].isspt == '0' || this.needProcess_origin[index].discheck)) {
            if (this.needProcess_origin[index].isspt == '1') {
              if (this.needProcess_origin[index].document_sts == "Document Complete") {
                this.needProcess_origin[index]["check"] = "1";
              }
            }
          });

          this.preparedToGenerate.loading.filter = !this.preparedToGenerate.loading.filter;
          this.preparedToGenerate.filtered = !this.preparedToGenerate.filtered;
          this.preparedToGenerate.loading.filter = !this.preparedToGenerate.loading.filter;
          this.preparedToGenerate.dis_TaxDt = !this.preparedToGenerate.dis_TaxDt;


          this.invoiceDttmpOri = this.invoiceDt;
          this.resetSearch();
          if (this.preparedToGenerate.bln_thn) {
            let newmonth = moment(this.preparedToGenerate.bln_thn).subtract(3, 'month');
            this.invoiceDt = [null, null],
              this.taxDt = [newmonth.clone().startOf('month'), this.preparedToGenerate.bln_thn.clone().endOf('month')];
            this.typetransaction = "all";
          }
        } else {
          this.displayMessageValue("basic-warning", "SPT Type and Periode must be selected!");
        }
      } else {
        const that = this;
        // this.$confirm({
        //   title: "Are you sure to discard this data?",
        //   content: "",
        //   okText: "Yes",
        //   cancelText: "No",
        //   onOk() {
        that.needProcess_origin.forEach((item, index) => {
          that.needProcess_origin[index]["discheck"] = true;
          that.needProcess_origin[index]["check"] = "0";
        });
        that.needProcess = that.needProcess_origin;
        Event.$emit("setvalcheckboxallselect", false);
        Event.$emit("setdisabledcheckboxallselect", true);
        that.preparedToGenerate.loading.filter = !that.preparedToGenerate.loading.filter;
        that.preparedToGenerate.filtered = !that.preparedToGenerate.filtered;
        that.preparedToGenerate.loading.filter = !that.preparedToGenerate.loading.filter;
        //that.preparedToGenerate.jenis_spt = undefined;
        that.preparedToGenerate.bln_thn = undefined;
        that.preparedToGenerate.dis_TaxDt = !that.preparedToGenerate.dis_TaxDt;
        that.invoiceDt = that.invoiceDttmpOri;
        that.refreshtabneedprocess();
        this.resetSearch();

        this.generateTax_value();
        //   },
        //   onCancel() { },
        // });
      }
    },
    generateTax_value() {
      let result = 0;
      this.needProcess.forEach((item) => {
        if (item.check === "1")
          result += Number(item.value);
      });
      this.preparedToGenerate.tax_value = result;
    },
    handlecheckall(val) {
      this.needProcess.forEach((item) => {
        let ind = _.findIndex(this.needProcess_origin, (e) => {
          return e.id_tax_transaction == item.id_tax_transaction;
        }, 0);
        if (this.needProcess_origin[ind].document_sts == 'Document Complete')
          this.needProcess_origin[ind]["check"] = val ? "1" : "0";
      });
      this.refreshtabneedprocess();
      this.generateTax_value();
      return true
    },
    refreshtabneedprocess() {
      let a = this.needProcess;
      this.tabs.loading = true;
      this.needProcess = [];
      this.needProcess = a;
      this.tabs.loading = false;
    },
    defaultfilterInvoiceDate() {
      let defFilterDateInvoice = localStorage.getItem("fid_" + this.getAuth.username);
      if (defFilterDateInvoice != null) {
        let tgl = CryptoJS.enc.Base64.parse(defFilterDateInvoice);
        tgl = CryptoJS.enc.Utf8.stringify(tgl);
        tgl = tgl.split(";")
        this.invoiceDt = [moment(tgl[0], "YYYY-MM-DD"), moment(tgl[1], "YYYY-MM-DD")];
      }
    },
    handleGenerate() {
      let cCentang = _.filter(this.needProcess, (el) => el.check == "1");
      if (cCentang.length == 0) {
        this.displayMessageValue("error-other", "No Data Checked!");
      } else {
        const that = this;
        this.$confirm({
          title: "Are you sure to generate this data?",
          onOk() {
            that.loading.generate = true;

            let trigger_Process =  true;
            let triggermessageData =  "";
            let selected_item = [];
            that.needProcess.forEach((item) => {
              if (item.check == "1"){
                selected_item.push({
                  id_tax_transaction: item.id_tax_transaction,
                });
                let duplicateDetectedData = _.filter(that.needProcess, (e) => e.type=='tax_verification' && e.no_trans == item.no_trans && e.check != "1");
                if(duplicateDetectedData.length>0){
                  trigger_Process = false;
                  triggermessageData = item.no_trans;
                  that.loading.generate = false;
                  return;
                }
              }
            });

            if(trigger_Process){
              let data = new FormData();
              data.append("jenis_spt", that.preparedToGenerate.jenis_spt);
              data.append("bulan_tahun", moment(that.preparedToGenerate.bln_thn).format("MM-YYYY"));
              data.append("tax_value", that.preparedToGenerate.tax_value);
              data.append("selected_item", JSON.stringify(selected_item));

              axios({
                method: "post",
                url: that.$serviceUrl + "spt/generate",
                processData: false,
                data: data,
                auth: {
                  username: that.getAuth.username,
                  password: that.getAuth.password,
                },
                headers: {
                  "Content-Type": "application/json",
                  "X-API-KEY": that.getAuth.apikey,
                },
              })
                .then((response) => {
                  that.loading.generate = false;
                  let templist_tax_detail = response.data.list_tax_detail;
                  for (let w = 0; w < templist_tax_detail.length; w++) {
                    templist_tax_detail[w]['check'] = "1";
                  }
                  let sourceto = {
                    information: response.data.information,
                    list_tax_detail: templist_tax_detail,
                    list_pbk: response.data.list_pbk ? response.data.list_pbk : null,
                    source: _.filter(that.needProcess, (e) => e.document_sts == 'Document Complete')
                  };

                  sourceto.information['jns'] = that.generate;
                  sourceto.information['total_nilai_label'] = response.data.total_nilai_label;

                  that.$router.push({
                    name: "SPTCreate",
                    params: sourceto,
                  });
                })
                .catch((err) => {
                  that.loading.generate = false;

                  let response = Object.assign({}, err.response);
                  if (response.data.status == false && response.data.message) {
                    that.displayMessageValue("error-other", response.data.message);
                  } else {
                    let responses = Object.assign({}, err.response.data);
                    //console.log(responses);
                    that.displayMessageValue("error", responses);
                  }
                });
            }else{
              console.log(triggermessageData)
              that.displayMessageValue("basic-warning", "Please Complete Data transsaction "+triggermessageData+" each other!");
            }
          },
          onCancel() { },
        });
      }
    },
    handleEditDraftSPT(data) {
      // this.loading.edit = true;
      // this.loading.modalDepositKey = data.spt_id;
      this.$router.push({
        name: "SPTEdit",
        params: { id: data.spt_id, tipe: data.tipe },
      });
    },
    handleshowManifest(data) {
      this.$router.push({
        name: "SPTManifest",
        params: { id: data.spt_id, tipe: data.spt_type },
      });
    },
    handleshowManifest2(data) {
      const route = this.$router.resolve({
        name: "SPTManifest",
        params: { id: data.spt_id, tipe: data.spt_type },
      });
      window.open(route.href, "_blank");

    },
    handleDeleteSPT(val) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.deletespt = true;
          Event.$emit("disableNext", true);
          that.loading.modalDepositKey = val.spt_id;
          that.asyncAxiosDelete(
            "spt",
            "application/json",
            that.getAuth,
            { spt_id: val.spt_id }
          )
            .then(() => {
              that.loading.deletespt = false;
              Event.$emit("disableNext", false);
              that.loading.modalDepositKey = "";
              that.displayMessage("success-del");
              that.handleTab(that.tabs.active);
            })
            .catch((err) => {
              that.loading.deletespt = false;
              Event.$emit("disableNext", false);
              that.loading.modalDepositKey = "";
              let responses = Object.assign({}, err.response.data);
              that.displayMessageValue("error-other", responses.message);
            });
        },
        onCancel() { },
      });
    },
    processmoreSearch() {
      let tempData = [];
      if (this.tabs.active == "listSPT") {
        tempData = this.listSPT_origin;
      } else if (this.tabs.active == "credittax") {
        tempData = this.credittax_origin;
      } else {
        tempData = this.needProcess_origin;
      }

      if (tempData.length > 0) {
        if (this.search && this.tabs.active == "listSPT") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_invoice &&
                obj.no_invoice
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_transaksi &&
                obj.no_transaksi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.catatan &&
                obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_bkk &&
                obj.no_bkk.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.due_date &&
                this.moment(obj.due_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_create &&
                obj.tlc_create
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_spt_rectification &&
                obj.no_spt_rectification
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.type_label &&
                obj.type_label.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "credittax") {
          tempData = tempData.filter(
            (obj) =>
              (obj.spt_no &&
                obj.spt_no
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_trans &&
                obj.no_trans
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.catatan &&
                obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.description &&
                obj.description
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.due_date &&
                this.moment(obj.due_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_create &&
                obj.tlc_create
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.type_label &&
                obj.type_label.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "needprocess") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_trans &&
                obj.no_trans.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.description &&
                obj.description
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tax_type_label &&
                obj.tax_type_label
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency("IDR", obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value_dpp &&
                this.formatCurrency("IDR", obj.value_dpp)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tax_date &&
                this.moment(obj.tax_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.type_label &&
                obj.type_label.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        }

        if (this.type && this.type !== "all") {
          tempData = tempData.filter(
            (obj) =>
              obj.type &&
              obj.type.toLowerCase() == this.type.toLowerCase()
          );
        }

        if (this.preparedToGenerate.filtered) {
          if (this.preparedToGenerate.jenis_spt == "ppn") {
            tempData = tempData.filter(
              (obj) =>
                obj.isspt == "1" &&
                obj.tax_type &&
                obj.tax_type.toLowerCase() == this.preparedToGenerate.jenis_spt.toLowerCase()
            );
          } else if (this.preparedToGenerate.jenis_spt == "pph_unifikasi") {
            tempData = tempData.filter(
              (obj) =>
                obj.isspt == "1" &&
                obj.tax_type &&
                obj.tax_type.toLowerCase() == "pph_22" ||
                obj.tax_type.toLowerCase() == "pph_23" ||
                obj.tax_type.toLowerCase() == "pph_pasal4"
            );
          } else if (this.preparedToGenerate.jenis_spt == "pph_21") {
            tempData = tempData.filter(
              (obj) =>
                obj.isspt == "1" &&
                obj.tax_type &&
                (obj.tax_type.toLowerCase() == "pph_21".toLowerCase() ||
                  obj.tax_type.toLowerCase() == "commision".toLowerCase())
            );
          } else {
            tempData = tempData.filter(
              (obj) =>
                obj.isspt == "1" &&
                obj.tax_type &&
                obj.tax_type.toLowerCase() == "pph_2529"
            );
          }
        } else {
          if (this.typetransaction && this.typetransaction !== "all") {
            //console.log("this.typetransaction",this.typetransaction)
            if (this.typetransaction == "pph_21") {
              tempData = tempData.filter(
                (obj) =>
                  obj.tax_type &&
                  (obj.tax_type.toLowerCase() == "pph_21".toLowerCase() ||
                    obj.tax_type.toLowerCase() == "commision".toLowerCase())
              );
            } else {
              tempData = tempData.filter(
                (obj) =>
                  obj.tax_type &&
                  obj.tax_type.toLowerCase() == this.typetransaction.toLowerCase()
              );
            }
          }

          if (this.isgenerateSPT && this.isgenerateSPT !== "all") {
            tempData = tempData.filter(
              (obj) =>
                obj.isspt &&
                obj.isspt.toLowerCase() == this.isgenerateSPT.toLowerCase()
            );
          }
        }

        if (this.transactionDt && this.transactionDt[0] && this.transactionDt[1]) {
          //console.log(this.transactionDt[0],this.transactionDt[1])
          let startDt = moment(this.transactionDt[0]).format("YYYY-MM-DD");
          let endDt = moment(this.transactionDt[1]).format("YYYY-MM-DD");
          tempData = tempData.filter(
            (obj) =>
              obj.trans_dt &&
              moment(obj.trans_dt).format("YYYY-MM-DD") >= startDt &&
              moment(obj.trans_dt).format("YYYY-MM-DD") <= endDt
          );
        }

        if (this.invoiceDt && this.invoiceDt[0] && this.invoiceDt[1]) {
          let startDti = moment(this.invoiceDt[0]).format("YYYY-MM-DD");
          let endDti = moment(this.invoiceDt[1]).format("YYYY-MM-DD");

          let d = startDti + ";" + endDti;
          let encrypt_fid = CryptoJS.enc.Utf8.parse(d);
          encrypt_fid = CryptoJS.enc.Base64.stringify(encrypt_fid);
          if (!this.preparedToGenerate.filtered)
            localStorage.setItem("fid_" + this.getAuth.username, encrypt_fid);

          tempData = tempData.filter(
            (obj) =>
              obj.invoice_dt &&
              moment(obj.invoice_dt).format("YYYY-MM-DD") >= startDti &&
              moment(obj.invoice_dt).format("YYYY-MM-DD") <= endDti
          );
        } else {
          localStorage.removeItem("fid_" + this.getAuth.username);
        }

        if (this.taxDt && this.taxDt[0] && this.taxDt[1]) {
          if (this.preparedToGenerate.filtered) {
            //let startDt = moment(this.taxDt[0]).format("YYYY-MM-DD");
            let startDtAR = moment(this.taxDt[1]).startOf('month').format("YYYY-MM-DD");
            let startDtNonAR = moment(this.taxDt[1]).clone().subtract(3, 'months').startOf('month').format("YYYY-MM-DD");
            let startDtPPh = moment(this.taxDt[1]).clone().subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
            let endDt = moment(this.taxDt[1]).format("YYYY-MM-DD");
            tempData = tempData.filter(
              (obj) =>
                obj.tax_date &&
                (
                  (obj.tax_type == "ppn" && (obj.type == "account_receivable" || obj.type == "account_receivable_sales_contract")
                    && moment(obj.tax_date).format("YYYY-MM-DD") >= startDtAR &&
                    moment(obj.tax_date).format("YYYY-MM-DD") <= endDt)
                  ||
                  (obj.tax_type == "ppn" && !(obj.type == "account_receivable" || obj.type == "account_receivable_sales_contract")
                    && moment(obj.tax_date).format("YYYY-MM-DD") >= startDtNonAR &&
                    moment(obj.tax_date).format("YYYY-MM-DD") <= endDt && !obj.tax_type.toLowerCase().includes('pph'))
                  ||
                  (obj.tax_type != "ppn" && moment(obj.tax_date).format("YYYY-MM-DD") >= startDtPPh &&
                    moment(obj.tax_date).format("YYYY-MM-DD") <= endDt)
                )
            );
          } else {
            let startDt = moment(this.taxDt[0]).format("YYYY-MM-DD");
            let endDt = moment(this.taxDt[1]).format("YYYY-MM-DD");
            tempData = tempData.filter(
              (obj) =>
                obj.tax_date &&
                moment(obj.tax_date).format("YYYY-MM-DD") >= startDt &&
                moment(obj.tax_date).format("YYYY-MM-DD") <= endDt
            );
          }
        }

        if (this.stsDocument != "" && this.stsDocument != undefined) {
          if (this.stsDocument == "yes") {
            tempData = tempData.filter(
              (obj) =>
                obj.document_sts && obj.document_sts == "Document Complete"
            );
          } else if (this.stsDocument == "no") {
            tempData = tempData.filter(
              (obj) =>
                obj.document_sts && obj.document_sts == "Document Not Complete"
            );
          }
        }

        if (this.tabs.active == "needprocess" && this.revisedStatus) {
          if (this.revisedStatus !== "all") {
            tempData = tempData.filter(
              (obj) => obj.button_aksi && obj.button_aksi == this.revisedStatus
            );
          }
        }
      }
      this.intoList(this.tabs.active, tempData);
      if (
        !this.tabs.active &&
        !this.search &&
        !this.transactionDt &&
        !this.invoiceDt &&
        !this.taxDt &&
        !this.type &&
        !this.typetransaction &&
        !this.isgenerateSPT
      ) {
        this.intoList(this.tabs.active, tempData);
      }
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead>tr>th {
  text-align: center;
}

.selectedRow {
  background-color: aliceblue !important;
}
</style>
